import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';

import { DashboardVehicle } from '../types/DashboardVehicle';

export const isVehicleApplicationRefandiType = (
  vehicle: DashboardVehicle,
): boolean => vehicle.application?.type === ApplicationType.RE_F_AND_I;
